import React from 'react';

const clampPercent = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.max(0, Math.min(100, Math.round(numeric)));
};

export default class ProjectProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { infoOpen: false };
    this.infoId = `project-progress-info-${Math.random().toString(36).slice(2, 9)}`;
  }

  toggleInfo = () => {
    this.setState((prev) => ({ infoOpen: !prev.infoOpen }));
  };

  closeInfo = () => {
    this.setState({ infoOpen: false });
  };

  handleInfoKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.closeInfo();
    }
  };

  handleRootKeyDown = (event) => {
    if (!this.props.onInfoClick) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.props.onInfoClick();
    }
  };

  render() {
    const {
      percent,
      isDraftComplete,
      isDemo,
      infoText,
      emptyStateText,
      completeStateText,
      onInfoClick,
    } = this.props;

    const normalizedPercent = clampPercent(percent ?? 0);

    const isCompleteState = !!isDraftComplete || normalizedPercent >= 100;

    const meterLabel = `Project draft workload progress ${normalizedPercent} percent`;

    return (
      <div
        className={`project-progress${isCompleteState ? ' is-complete' : ''}${isDemo ? ' is-demo' : ''}${onInfoClick ? ' is-clickable' : ''}`}
        role={onInfoClick ? 'button' : undefined}
        tabIndex={onInfoClick ? 0 : undefined}
        onClick={onInfoClick || undefined}
        onKeyDown={this.handleRootKeyDown}
        title={onInfoClick ? 'Open writing progress' : undefined}
      >
        <div className="project-progress-bar-row">
          <div className="project-progress-track" role="presentation">
            <div
              className="project-progress-fill"
              role="progressbar"
              aria-label={meterLabel}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={normalizedPercent}
              style={{ width: `${normalizedPercent}%` }}
            />
            <span
              className={`project-progress-fill-label${normalizedPercent === 0 ? ' is-zero' : ''}`}
              aria-hidden="true"
            >
              {normalizedPercent}%
            </span>
          </div>
          <div className="project-progress-info-wrap" onKeyDown={onInfoClick ? undefined : this.handleInfoKeyDown}>
            <button
              type="button"
              className="project-progress-info-btn"
              aria-label={onInfoClick ? 'View writing progress details' : 'How progress is calculated'}
              aria-expanded={onInfoClick ? undefined : this.state.infoOpen}
              aria-controls={onInfoClick ? undefined : this.infoId}
              onClick={(event) => {
                if (onInfoClick) {
                  event.stopPropagation();
                  onInfoClick();
                  return;
                }
                this.toggleInfo();
              }}
            >
              {onInfoClick ? (
                <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
                  <circle cx="10" cy="10" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
                  <line x1="14.8" y1="14.8" x2="20.5" y2="20.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              ) : (
                'i'
              )}
            </button>
            {!onInfoClick && this.state.infoOpen && (
              <div id={this.infoId} className="project-progress-tooltip" role="tooltip">
                {infoText || 'Progress is based on completed chapters divided by total active chapters.'}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
